import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        top: 0, 
        left: 0, 
        right: 0,
        bottom: 0
    },
    modal: {
        alignItems: 'center',
        justifyContent: 'center'
    },
    paper: {
        height: '380px',
        width: '700px',
        position: 'absolute', 
        top: '50%',
        left: '50%', 
        transform: 'translate(-50%, -50%)', 
        padding: '15px',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5]
    },
    paperList: {
        overflow: 'auto',
        marginLeft: '-20px',
        marginRight: '20px'
    },
    listSize: {
        maxHeight: '250px',
        padding: '5px'
    },
    listItem: {
        borderRadius: '5px',
        border: '1px solid #3068FA',
        marginBottom: '5px'
    },
    listItemSelected: {
        borderRadius: '5px',
        border: '1px solid #3068FA',
        marginBottom: '5px'
    },
    listText: {
        display: 'flex', 
        justifyContent: 'center',
        fontWeight: 'bold',
        color: '#3068FA'
    },
    closeButton: {
        position: 'absolute', 
        top: 10,
        right: 10,
        color: 'gray',
        cursor: 'pointer'
    },
    loadingPosition: {
        paddingTop: '50px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%'
    },
    buttonProgress: {
        color: '#4E92FA'
    }
  }));
